<script>
export default {
    name: 'BaseCalendarViewMonth',
};
</script>

<script setup>
import { computed, watchEffect } from 'vue';
import { getWeekdays, getMonthlyCalendarGrid } from '@/components/base-components/components/calendar/utils/ranges.js';

const props = defineProps({
    date:           {
        type:     Date,
        required: true,
    },
    firstDayOfWeek: {
        type:    Number,
        default: 1,
    },
    noWeekends:     {
        type: Boolean,
    },
    titleClass:     {
        type: [String, Array, Object],
    },
    gridClass:      {
        type: [String, Array, Object],
    },
});

const emit = defineEmits({
    range: null,
});

const days = computed(() => getWeekdays(props.date, props.firstDayOfWeek, props.noWeekends));
const dates = computed(() => getMonthlyCalendarGrid(props.date, props.firstDayOfWeek, props.noWeekends));

watchEffect(() => {
    emit('range', dates.value.map(({ date }) => date));
});
</script>

<template>
    <div
        class="grid"
        :class="[
            gridClass || [
                'grid-rows-[auto_repeat(6,1fr)]',
                noWeekends ? 'grid-cols-5' : 'grid-cols-7',
            ]
        ]"
    >
        <template v-for="(day, index) in days">
            <slot v-bind="day" name="title" :index="index" />
        </template>

        <template v-for="(day, index) in dates">
            <slot v-bind="day" name="cell" :index="index" />
        </template>

        <slot name="content" />
    </div>
</template>
